<template>
  <span :class="classes"><slot></slot></span>
</template>
<script setup lang="ts">
import { computed } from "vue";

import type { Variant, Size } from "./types";

export interface PillProps {
  variant?: Variant;
  size?: Size;
}

const classes = computed(() => {
  return [
    "tw-m-1 tw-rounded tw-bg-white tw-px-1 tw-pt-0.5 tw-text-xs tw-font-normal tw-uppercase",
  ];
});
</script>
